<template>
    <div>
        <kgr-form-scaffold
            :with-primary-buttons="false"
            @backBtnClicked="redirectToOverview"
        >
            <kgr-club-employee-roles-data-form
                :roles="roles"
                :club-id="clubId"
                :employee-id="employeeId"
                class="animated fadeIn"
                :is-creatable="isCreatable"
                @updated="loadRoles"
            />
        </kgr-form-scaffold>
    </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref } from 'vue';
import ClubEmployeeRepository from '../../js/repository/ClubEmployeeRepository';
import KgrClubEmployeeRolesDataForm from '../../components/employees/roles/ClubEmployeeRolesDataForm';
import KgrFormScaffold from '../../components/common/form/FormScaffold';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps({
    overviewUrl: {
        type: String,
        required: true,
    },
    employeeId: {
        type: Number,
        required: true,
    },
    clubId: {
        type: Number,
        required: true,
    },
    isCreatable: {
        type: Boolean,
        required: true,
    },
});

const { proxy } = getCurrentInstance();
const roles = ref([]);

function loadRoles() {
    ClubEmployeeRepository.getClubEmployeeRolesData(props.employeeId)
        .then((loadedRoles) => {
            roles.value = loadedRoles;
        })
        .catch(() => proxy.$notify.error('error.loadingData'));
}

function redirectToOverview() {
    window.location = props.overviewUrl;
}

onMounted(loadRoles);
</script>
